import {
  Component,
  inject,
  HostListener,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe, Location } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { Sort } from '@angular/material/sort';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { SessionManagerService } from '../../../core/services/session-manager/session-manager.service';
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.css',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    RouterLink,
    TranslateModule,
  ],
})
export class NavigationComponent implements OnChanges, OnInit, OnDestroy {
  private breakpointObserver = inject(BreakpointObserver);
  submenuOrders = false;
  submenuInvoices = false;
  account_name: any;
  submenuOpen: boolean = false;
  submenuOpenConf: boolean = false;
  crearPanelOpen: boolean = false;
  settingsPanelOpen: boolean = false;
  submenuPosition = { top: '0px', left: '0px' };
  closeTimeout: any;
  closeTimeoutConf: any;
  name: any = 'Negocio';
  type: any = 'broker';
  role: any = 'admin';

  submenuState: { [key: string]: boolean } = {};


  menuItems: any;

  private sessionSub?: Subscription;

  constructor(
    private localStorageService: LocalStorageService,
    private location: Location,
    private authStateService: AuthStateService,
    private sessionManager: SessionManagerService,
    private cdr: ChangeDetectorRef
  ) {
    this.refreshFromAuthState();
  }

  ngOnInit(): void {
    this.sessionSub = this.sessionManager.activeIndex$.subscribe(() => {
      this.refreshFromAuthState();
    });
  }

  ngOnDestroy(): void {
    this.sessionSub?.unsubscribe();
  }

  private refreshFromAuthState(): void {
    this.name = this.authStateService.getName();
    this.account_name = this.authStateService.getAccountName();
    this.role = this.authStateService.getRole();
    this.type = this.authStateService.getAccountType();
    this.menuItems = this.authStateService.getMenuItems();
    this.cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['drawerOpen'] && !changes['drawerOpen'].currentValue) {
      this.crearPanelOpen = false;
      this.settingsPanelOpen = false;
      this.submenuOpen = false;
      this.submenuOpenConf = false;
    }
  }

  toggleSubmenuNav(key: string): void {
    // Si el submenu clickeado ya está abierto, lo cerramos (toggle)
    if (this.submenuState[key]) {
      this.submenuState[key] = false;
    } else {
      // Si no está abierto, cerramos todos los demás y abrimos el clickeado
      Object.keys(this.submenuState).forEach(k => {
        this.submenuState[k] = false;
      });
      this.submenuState[key] = true;
    }
  }

  crearPanelTop = '0px';
  settingsPanelTop = '0px';

  toggleSubmenu(event: MouseEvent): void {
    // Cerrar panel settings si está abierto (exclusividad)
    if (this.isMobile && this.settingsPanelOpen) {
      this.settingsPanelOpen = false;
      this.submenuOpenConf = false;
    }
    this.submenuOpen = !this.submenuOpen;
    this.crearPanelOpen = this.isMobile ? this.submenuOpen : false;
    const target = (event.target as HTMLElement).closest(
      '.has-submenu'
    ) as HTMLElement;
    if (this.submenuOpen && target) {
      const rect = target.getBoundingClientRect();
      if (this.isMobile) {
        const sidebar = target.closest('.sidebar-drawer') as HTMLElement;
        const sidebarRect = sidebar?.getBoundingClientRect();
        this.crearPanelTop = `${rect.top - (sidebarRect?.top || 0)}px`;
      } else {
        this.submenuPosition = {
          top: `${rect.top}px`,
          left: `${rect.right}px`,
        };
      }
    }
    event.stopPropagation();
  }

  startCloseTimeout(): void {
    if (this.isMobile) return;
    this.closeTimeout = setTimeout(() => {
      this.submenuOpen = false;
    }, 3000);
  }

  cancelCloseTimeout(): void {
    if (this.isMobile) return;
    this.submenuOpen = true;
    clearTimeout(this.closeTimeout);
  }

  toggleSubmenuConf(event: MouseEvent): void {
    // Cerrar panel crear si está abierto (exclusividad)
    if (this.isMobile && this.crearPanelOpen) {
      this.crearPanelOpen = false;
      this.submenuOpen = false;
    }
    this.submenuOpenConf = !this.submenuOpenConf;
    this.settingsPanelOpen = this.isMobile ? this.submenuOpenConf : false;
    const target = (event.target as HTMLElement).closest(
      '.has-submenu'
    ) as HTMLElement;
    if (this.submenuOpenConf && target) {
      const rect = target.getBoundingClientRect();
      if (this.isMobile) {
        const sidebar = target.closest('.sidebar-drawer') as HTMLElement;
        const sidebarRect = sidebar?.getBoundingClientRect();
        this.settingsPanelTop = `${rect.top - (sidebarRect?.top || 0)}px`;
      } else {
        this.submenuPosition = {
          top: `${rect.top}px`,
          left: `${rect.right}px`,
        };
      }
    }
    event.stopPropagation();
  }
  startCloseTimeoutConf(): void {
    if (this.isMobile) return;
    this.closeTimeoutConf = setTimeout(() => {
      this.submenuOpenConf = false;
    }, 3000);
  }

  cancelCloseTimeoutConf(): void {
    if (this.isMobile) return;
    this.submenuOpenConf = true;
    clearTimeout(this.closeTimeoutConf);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.submenuOpen) {
      this.submenuOpen = false;
      this.crearPanelOpen = false;
    }
    if (this.submenuOpenConf) {
      this.submenuOpenConf = false;
      this.settingsPanelOpen = false;
    }
  }
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  @Input() collapsed = false;
  @Input() isMobile = false;
  @Input() drawerOpen = false;
  @Output() toggle = new EventEmitter<boolean>();
  @Output() drawerClosed = new EventEmitter<void>();

  toggleNavigation(boolean: any): void {
    this.closeAllSubmenus();
    this.crearPanelOpen = false;
    this.settingsPanelOpen = false;
    this.submenuOpen = false;
    this.submenuOpenConf = false;
    this.collapsed = boolean;
    this.toggle.emit(boolean);
  }

  closeAllSubmenus(): void {
    const traverse = (items: any[]) => {
      for (const item of items) {
        if (item.key) {
          this.submenuState[item.key] = false;
        }
        if (item.children) {
          traverse(item.children);
        }
      }
    };

    traverse(this.menuItems);
  }

  toggleNavigationFalse(): void {
    this.toggle.emit(false);
  }

  closeDrawer(): void {
    this.crearPanelOpen = false;
    this.settingsPanelOpen = false;
    this.submenuOpen = false;
    this.submenuOpenConf = false;
    this.drawerClosed.emit();
  }

  onMenuItemClick(): void {
    if (this.isMobile) {
      this.crearPanelOpen = false;
      this.settingsPanelOpen = false;
      this.submenuOpen = false;
      this.submenuOpenConf = false;
      this.closeDrawer();
    }
  }
}
